module.exports = __webpack_public_path__ + "static/media/takeTwoAces_1.92478a22.png";